<template>
  <div class="container">
    <div class="card shadow pt-2 ps-3 pe-3">
      <div class="row">
        <div class="col-md-6 mt-4">
          <div class="form-group">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/inicio">Início</a>
                </li>
                <li class="breadcrumb-item">
                  <a href="/colunas">Colunas</a>
                </li>
                <li class="breadcrumb-item">
                  <a style="color: grey; hover: none">Cadastrar Coluna</a>
                </li>
              </ol>
              <h3 style="color: #000; margin-left: 15px">Cadastrar Coluna</h3>
            </nav>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-6">
          <label>Título</label>
          <input
            type="text"
            class="form-control"
            v-model="state.titulo.value"
            placeholder="Insira um título"
          />
          <span v-if="state.titulo.error" class="text-danger"
            >Este campo é obrigatório</span
          >
        </div>
        <div class="col-6">
          <label>URL</label>
          <input
            type="text"
            class="form-control"
            v-model="state.titulo_url.value"
            placeholder="Insira uma url"
          />
          <span v-if="state.titulo_url.error" class="text-danger"
            >Este campo é obrigatório</span
          >
        </div>
        <div class="col-4">
          <div class="form-group">
            <label>Status</label>
            <select class="form-select" v-model="state.status">
              <option value="ATIVO">Ativo</option>
              <option value="INATIVO">Inativo</option>
            </select>
          </div>
        </div>
        <div class="col-4">
          <label for="destaque1">Destaque 1</label>
          <select id="destaque1" v-model="state.destaque1" class="form-select">
            <option value="SIM">Sim</option>
            <option value="NAO">Não</option>
          </select>
        </div>
        <div class="col-4">
          <label for="destaque2">Destaque 2</label>
          <select id="destaque2" v-model="state.destaque2" class="form-select">
            <option value="SIM">Sim</option>
            <option value="NAO">Não</option>
          </select>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label>Colunista</label>
            <select class="form-select" v-model="state.colunista_id.value">
              <option
                v-for="colunista in state.colunistas"
                :key="colunista.id"
                :value="colunista.id"
              >
                {{ colunista.nome }}
              </option>
            </select>
            <span v-if="state.colunista_id.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label for="texto">Texto da Notícia</label>
            <textarea
              class="form-control"
              id="texto"
              v-model="state.text.value"
              rows="20"
            >
            </textarea>
            <span v-if="state.text.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-auto">
          <button
            class="btn btn_voltar btn-secondary me-3"
            id="voltar-button"
            type="submit"
            @click="router.push({ name: 'coluna' })"
          >
            Voltar
          </button>
          <button
            class="btn btn_salvar float-end"
            id="submit-button"
            type="submit"
            @click="salvarColuna"
          >
            Cadastrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: "",
      titulo: {
        value: "",
        error: false,
      },
      titulo_url: {
        value: "",
        error: false,
      },
      destaque1: "NAO",
      destaque2: "NAO",
      text: {
        value: "",
        error: false,
      },
      status: "ATIVO",
      colunista_id: {
        value: "",
        error: false,
      },
      colunistas: [],
    });

    onMounted(() => {
      fetchColunista();
      if (router.currentRoute._value.params.id != undefined) {
        fetchColunaById();
      }
    });
    async function fetchColunaById() {
      try {
        const { data } = await services.coluna.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.id = data.id;
        state.colunista_id.value = data.colunista_id;
        state.titulo.value = data.titulo;
        state.text.value = data.texto;
        state.titulo_url.value = data.titulo_url;
        state.destaque1 = data.destaque1;
        state.destaque2 = data.destaque2;
        state.status = data.status;
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchColunista() {
      try {
        const { data } = await services.colunista.getAll({ token });
        state.colunistas = data;
        console.log(state.colunistas);
      } catch (error) {
        console.log(error);
      }
    }
    async function salvarColuna() {
      var erro_validacao = false;

      if (state.titulo.value.length == 0) {
        state.titulo.error = true;
        erro_validacao = true;
      }
      if (state.titulo_url.value.length == 0) {
        state.titulo_url.error = true;
        erro_validacao = true;
      }
      if (state.colunista_id.value.length == 0) {
        state.colunista_id.error = true;
        erro_validacao = true;
      }
      if (state.text.value.length == 0) {
        state.text.error = true;
        erro_validacao = true;
      }

      if (erro_validacao == true) {
        return;
      }

      let dados = {
        colunista_id: state.colunista_id.value,
        titulo: state.titulo.value,
        texto: state.text.value,
        destaque1: state.destaque1,
        titulo_url: state.titulo_url.value,
        destaque2: state.destaque2,
        status: state.status,
        token,
      };
      if (!state.id) {
        await services.coluna
          .save(dados, token)
          .then((data) => {
            console.log(data);
            router.push({ name: "coluna" });
          })
          .catch((error) => {
            var valores = Object.values(error.response.data.errors);
            valores.forEach((element) => {
              element.forEach((element2) => {
                alert(element2);
              });
            });
          });
      } else {
        dados.id = state.id;
        try {
          console.log(dados);
          await services.coluna
            .update(dados, token)
            .then((data) => {
              console.log(data);
              router.push({ name: "coluna" });
            })
            .catch((error) => {
              var valores = Object.values(error.response.data.errors);
              valores.forEach((element) => {
                element.forEach((element2) => {
                  alert(element2);
                });
              });
            });
        } catch (error) {
          console.log(error);
        }
      }
    }
    return {
      router,
      state,
      salvarColuna,
    };
  },
};
</script> 

<style scoped>
label {
  font-size: 14pt;
  color: #000;
  margin-bottom: 0;
}
input {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
}
input:focus {
  border: solid 1px blue;
}
select {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
}
select:focus {
  border: solid 1px blue;
}
textarea {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
  resize: none;
}
textarea:focus {
  border: solid 1px blue;
}
.card {
  min-height: 94.8vh;
}

.btn_salvar {
  background: green;
  color: #fff;
  transform: none;
}
#descricao {
  resize: none;
}
.btn_salvar:hover {
  color: #fff;
}
.btn_deletar_imagem {
  width: 25px;
  height: 25px;
  margin-left: 3px;
  background: rgb(170, 0, 0);
  color: #fff;
  border: solid 1px rgb(170, 0, 0);
  border-radius: 5px;
  transition: 0.3s;
}
.btn_deletar_imagem:hover {
  background: rgb(228, 0, 0);
  color: #fff;
  border: solid 1px rgb(228, 0, 0);
}
.imagem {
  height: 120px;
  width: 120px;
  border-radius: 100px;
  border: 3px solid #838181;
}
textarea {
  resize: none;
}
.breadcrumb {
  background: #fff;
  margin-bottom: 0;
}
a {
  color: #000;
  font-family: "PoppinsMedium";
  transition: 0.2s;
}
a:hover {
  color: #93c01f;
}
</style>